import {json} from "p3";
import GameScene from "../../../scenes/GameScene";
import NPCStatusIndicator from "../../../ui/NPCStatusIndicator";
import Actor from "../Actor";

export default class NPC extends Actor {
    /**
     * @param {string} id
     */
    constructor(id) {
        super(id);

        this.interactable = true;

        this._metadata = json(id);
        this._dialog = json(this._metadata.character.dialog);

        this._status = null;
        this._tween = null;

        this.introduce = true;
        this.turnToFacePlayer = true;

        this.playerRespawnPos = new PIXI.Point(-100, 0);
    }

    init() {
        super.init();
    }

    destroy() {
        super.destroy();
    }

    onViewAdded() {
        super.onViewAdded();

        this._status = new NPCStatusIndicator();
        this._status.position.set(0, -this._view.height);
        this.addChild(this._status);
    }

    update() {
        super.update();

        if (this._status) {
            this._status.scale.x = this.scale.x;
            this._status.update();
        }
    }

    onInteractWith() {
        super.onInteractWith();
    }

    onInteractionRangeEnter() {
        super.onInteractionRangeEnter();
        this._status && this._status.animateGrow().then();
    }

    onInteractionRangeUpdate() {
        super.onInteractionRangeUpdate();
    }

    onInteractionRangeExit() {
        super.onInteractionRangeExit();
        this._status && this._status.animateShrink().then();
    }

    /**
     * @param {number} [scalar=1]
     */
    animateIdle(scalar = 1) {
        this.stopAnimation();

        this._tween = gsap.timeline({ delay: Math.random(), repeat: -1 });
        GameScene.active.addTween(this._tween);

        this._tween.add(gsap.to(this._view.scale, 0.6 * scalar, {
            y: 0.98,
            ease: Linear.easeNone
        }));
        this._tween.add(gsap.to(this._view.scale, 0.8 * scalar, {
            y: 1,
            ease: Back.easeOut
        }));
    }

    stopAnimation() {
        if (this._tween) {
            GameScene.active.removeTween(this._tween, true);
            this._tween = null;
        }
    }

    /**
     * @returns {string}
     */
    get id() {
        return this._id;
    }

    /**
     * @returns {object}
     */
    get metadata() {
        return this._metadata;
    }

    /**
     * @returns {object}
     */
    get dialog() {
        return this._dialog;
    }

    /**
     * @return {NPCStatusIndicator}
     */
    get status() {
        return this._status;
    }
}